import React from 'react';
import {TextMessage} from 'components/tt-forms/common';
import {Link, browserHistory} from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import { Reception } from 'api';
import { ShowIf } from 'components/utils';

class KetQuaThongTinGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      id: this.props.id,
      donId: this.props.donId,
      listTaiLieuVanThu: [],
      yKienXuLyKetQuaGiaiQuyet: '',
      showAttach: false
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.id,
      donId: nextProps.donId
    })
    this.getDetailReception(nextProps.id);
  }

  componentDidMount() {
    this.getDetailReception(this.props.id)
  }
  getDonInfo(inputId) {
    Reception.actions.getDonInfo.request({ id: inputId }).then(res => {
      if (res.data) {
        this.setState({
          listTaiLieuVanThu: res.data.listTaiLieuVanThu
        });
      }
    });
  }
  getDetailReception(id) {
    Reception.actions.getDetailReception.request({id: id}).then(res => {
      if (res.data) {
        this.getDonInfo(res.data.donSTCD.donId);
        this.setState({
          yKienXuLyKetQuaGiaiQuyet: res.data.yKienXuLyKetQuaGiaiQuyet,
          showAttach: true
        })
      } else {
        this.setState({
          yKienXuLyKetQuaGiaiQuyet: '',
          showAttach: true
        })
      }
    });
  }

  onClickClose() {
    browserHistory.goBack();
  }

  render() {
    return (
      <section className="wrap-block">
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className='title-14 mb15'>Thông tin giải quyết</h2>
        <div className='row pl10 pr10'>
          <TextMessage className='col-100' value={this.state.yKienXuLyKetQuaGiaiQuyet} label='Ý kiến xử lý'/>
          <ShowIf condition={this.state.showAttach}>
            <div className="col-100 pb5">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" dataShow={this.state.listTaiLieuVanThu} disableAttachFile={true} hideDescription={true}/>
            </div>
          </ShowIf>
          <div className="box-bottom gqd-wrap col-100">
            <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      </section>
    );
  }
}

KetQuaThongTinGiaiQuyet.defaultProps = {
  dataTaiLieuVanThu: '',
  yKienXuLyKetQuaGiaiQuyet: '',
  validators: {}
}

export default KetQuaThongTinGiaiQuyet;


// WEBPACK FOOTER //
// ./src/components/modules/reception/KetQuaThongTinGiaiQuyet.jsx